export const ShotTypes = ["shovel", "wrist", "snap", "slapShot", "backhand"];

export const VideoReviewOptions = ["upheld", "rejected"];
